PrizePots = {};
PrizePots.PotPrizeContianer = undefined;
PrizePots.MegaPotText = undefined;
PrizePots.MajorPotText = undefined;
PrizePots.MiniPotText = undefined;
PrizePots.MinorPotText = undefined;

PrizePots.MegaPot = undefined;
PrizePots.MajorPot = undefined;
PrizePots.MiniPot = undefined;
PrizePots.MinorPot = undefined;
PrizePots.MegaGlow = undefined;
PrizePots.MajorGlow = undefined;
PrizePots.MiniGlow = undefined;
PrizePots.MinorGlow = undefined;

PrizePots.MiniGlowEmitter = undefined;
PrizePots.MinorGlowEmitter = undefined;
PrizePots.MajorGlowEmitter = undefined;
PrizePots.MegaGlowEmitter = undefined;

PrizePots.PotPrizeReelSpin = undefined;
PrizePots.PotPrizeReelSpinLoop = undefined;
PrizePots.PotPrizeMinorReelSpin = undefined;
PrizePots.PotPrizeMiniReelSpin = undefined;
PrizePots.PotPrizeMajorReelSpin = undefined;
PrizePots.PotPrizeMegaReelSpin = undefined;

// NEW ANIMATION
PrizePots.MiniTitleSpriteFilePath = "Base_Game/Pots/Tiddler.png";
PrizePots.MinorTitleSpriteFilePath = "Base_Game/Pots/Lunker.png";
PrizePots.MajorTitleSpriteFilePath = "Base_Game/Pots/Whopper.png";
PrizePots.MegaTitleSpriteFilePath = "Base_Game/Pots/Monster.png";

PrizePots.HorseShoesSymbolTitle = [];
PrizePots.PotIndex = 0;
PrizePots.PotPrizes = [];
PrizePots.PotPrizesToDisplay = [];
PrizePots.onCompleteCallback = undefined;

PrizePots.potWinText = undefined;
PrizePots.potWinTextTween = undefined;

PrizePots.initialise = function () {
  PrizePots.stakeController = resourceManager.getController("stakeController");

  PrizePots.monsterPotText = resourceManager.get("postReels:PrizePotsContainer:monsterCashText");
  PrizePots.whopperPotText = resourceManager.get("postReels:PrizePotsContainer:whopperCashText");
  PrizePots.lunkerPotText = resourceManager.get("postReels:PrizePotsContainer:lunkerCashText");
  PrizePots.tiddlerPotText = resourceManager.get("postReels:PrizePotsContainer:tiddlerCashText");

  PrizePots.PotPrizeContianer = resourceManager.get("postReels:PrizePotsReelContainer");

  PrizePots.PotPrizeReelSpin = resourceManager.get("postReels:PrizePotsReelContainer:PrizePotsIntialSpin");

  PrizePots.PotPrizeReelSpinLoop = resourceManager.get("postReels:PrizePotsReelContainer:PrizePotsSpinLoop");

  PrizePots.PotPrizeMinorReelSpin = resourceManager.get("postReels:PrizePotsReelContainer:PrizePotsSpinMinor");
  PrizePots.PotPrizeMiniReelSpin = resourceManager.get("postReels:PrizePotsReelContainer:PrizePotsSpinMini");
  PrizePots.PotPrizeMiniReelSpinA1 = resourceManager.get("postReels:PrizePotsReelContainer:PrizePotsSpinMiniA1");
  PrizePots.PotPrizeMiniReelSpinA2 = resourceManager.get("postReels:PrizePotsReelContainer:PrizePotsSpinMiniA2");
  PrizePots.PotPrizeMajorReelSpin = resourceManager.get("postReels:PrizePotsReelContainer:PrizePotsSpinMajor");
  PrizePots.PotPrizeMegaReelSpin = resourceManager.get("postReels:PrizePotsReelContainer:PrizePotsSpinMega");

  PrizePots.PotPrizeReelSpin.visible = false;
  PrizePots.PotPrizeReelSpinLoop.visible = false;
  PrizePots.PotPrizeMinorReelSpin.visible = false;
  PrizePots.PotPrizeMiniReelSpin.visible = false;
  PrizePots.PotPrizeMiniReelSpinA1.visible = false;
  PrizePots.PotPrizeMiniReelSpinA2.visible = false;
  PrizePots.PotPrizeMajorReelSpin.visible = false;
  PrizePots.PotPrizeMegaReelSpin.visible = false;

  PrizePots.MiniPotVariations = [
    PrizePots.PotPrizeMiniReelSpin,
    PrizePots.PotPrizeMiniReelSpinA1,
    PrizePots.PotPrizeMiniReelSpinA2,
  ];

  Reflex.registerEventHandler("orientationChange", PrizePots.orientationChange.bind(this));
  messageBus.subscribe("stake:stakeChanged", PrizePots.onStakeChanged.bind(this));
  PrizePots.updatePrizePot();
};

PrizePots.onStakeChanged = () => {
  PrizePots.updatePrizePot();
};

PrizePots.updatePrizePot = function () {
  const newStake = gameController.globalHelperGetCurrentModeStake(true);

  const monsterPotCashValue = (gameData.megaPotValue / gameData.winlineValue) * newStake;
  PrizePots.monsterPotText.setText(gdk.formatCurrency(monsterPotCashValue, false));

  const whopperPotCashValue = (gameData.majorPotValue / gameData.winlineValue) * newStake;
  PrizePots.whopperPotText.setText(gdk.formatCurrency(whopperPotCashValue, false));

  const lunkerPotCashValue = (gameData.minorValue / gameData.winlineValue) * newStake;
  PrizePots.lunkerPotText.setText(gdk.formatCurrency(lunkerPotCashValue, false));

  const tiddlerPotCashValue = (gameData.miniValue / gameData.winlineValue) * newStake;
  PrizePots.tiddlerPotText.setText(gdk.formatCurrency(tiddlerPotCashValue, false));
};

PrizePots.awardPrizePot = function (postRespins, callback) {
  gameController.prizePotAnimationsComplete = false;

  let coins;

  if (gameController.inFreeSpins) {
    coins = gameController.coins;
    // coins = gameController.coinAwardsBeforeGoldenSpins.coins;
  } else {
    coins = gameController.coinAwards.coins;
  }

  if (coins && coins.length > 0) {
    PrizePots.PotPrizesToDisplay = [];

    for (let index = 0; index < coins.length; index++) {
      const coin = gameController.inFreeSpins ? coins[index] : coins[index].coin;
      if (coin.type === "Pot" && (!CloverRespins?.respinData?.isAwarded || postRespins)) {
        let canAdd = true;
        for (let p = 0; p < PrizePots.PotPrizes.length; p++) {
          const prizePot = PrizePots.PotPrizes[p];
          if (coin.coord.reel === prizePot.coord.reel && coin.coord.row === prizePot.coord.row) {
            canAdd = false;
            break;
          }
        }
        if (canAdd) {
          if (helper.isPotOnReel(coin.coord.reel, coin.coord.row)) {
            PrizePots.PotPrizes.push(coin);
            PrizePots.PotPrizesToDisplay.push(coin);
          }
        }
      }
    }

    if (PrizePots.PotPrizesToDisplay.length > 0) {
      gameController.canSkipWin = false;
      gameController.coinsCurrentlySkippable = false;
      PrizePots.sortArrayByCoord(PrizePots.PotPrizesToDisplay);
      PrizePots.potReveal();
    } else {
      gameController.prizePotAnimationsComplete = true;
      if (PrizePots.onCompleteCallback !== undefined) {
        PrizePots.onCompleteCallback();
        PrizePots.onCompleteCallback = undefined;
      }
    }
  } else {
    gameController.prizePotAnimationsComplete = true;
    if (PrizePots.onCompleteCallback !== undefined) {
      PrizePots.onCompleteCallback();
      PrizePots.onCompleteCallback = undefined;
    }
  }
};

PrizePots.potReveal = function () {
  const pot = PrizePots.PotPrizesToDisplay[0];

  const staticSymbol = resourceManager.get(
    `slotContainer:reelContainer:reel${pot.coord.reel}:symbol${pot.coord.row}:symbol`
  );

  // Position the POT PRIZE REEL SPIN over the symbol that has triggered the feautre * POS AND SCALE *
  const globalPosition = helper.getLocalFromGlobalPosition(staticSymbol, PrizePots.PotPrizeReelSpin);
  PrizePots.PotPrizeReelSpin.position.set(globalPosition.x, globalPosition.y);
  PrizePots.PotPrizeReelSpin.scale.set(0.35);

  PrizePots.PotPrizeReelSpin.gotoAndStop(0);
  PrizePots.PotPrizeReelSpin.visible = true;

  const potPrizeReelSpinOriginalPos = PrizePots.PotPrizeReelSpin.Props[layoutController.getCurrentLayout()];

  soundManager.play("horseshoeWhoosh");
  gsap.to(PrizePots.PotPrizeReelSpin.position, {
    duration: 0.5,
    ease: "linear",
    x: potPrizeReelSpinOriginalPos.position.x,
    y: potPrizeReelSpinOriginalPos.position.y,
  });
  gsap
    .timeline()
    .to(PrizePots.PotPrizeReelSpin.scale, {
      duration: 0.5,
      ease: "linear",
      x: 1,
      y: 1,
    })
    .to(PrizePots.PotPrizeReelSpin.scale, {
      duration: 0.05,
      ease: "linear",
      x: 1.2,
      y: 1.2,
    })
    .to(PrizePots.PotPrizeReelSpin.scale, {
      duration: 0.05,
      ease: "linear",
      x: 1,
      y: 1,
      onComplete: () => {
        musicManager.playPotCollect();
        soundManager.play("horseshoeSpin");
        PrizePots.PotPrizeReelSpin.play();
        PrizePots.PotPrizeReelSpin.onComplete = PrizePots.RepeatSpinAnimation.bind(this, pot, 0);
      },
    });
};

PrizePots.RepeatSpinAnimation = function (pot, count) {
  PrizePots.PotPrizeReelSpin.visible = false;
  PrizePots.PotPrizeReelSpinLoop.visible = true;
  PrizePots.PotPrizeReelSpinLoop.gotoAndStop(0);
  PrizePots.PotPrizeReelSpinLoop.play();

  if (count >= 4) {
    PrizePots.PotPrizeReelSpinLoop.onComplete = PrizePots.playPotPrizeReelSpin.bind(this, pot);
  } else {
    PrizePots.PotPrizeReelSpinLoop.onComplete = PrizePots.RepeatSpinAnimation.bind(this, pot, count + 1);
  }
};

PrizePots.PulsePot = function (pot) {
  //let PotGlow;
  let PotValue;
  let scaleDown = { x: 0.35, y: 0.35 };
  switch (pot.potName) {
    case "Mini":
      //PotGlow = PrizePots.MiniGlow;
      PotValue = PrizePots.tiddlerPotText;
      break;
    case "Minor":
      //PotGlow = PrizePots.MinorGlow;
      PotValue = PrizePots.lunkerPotText;
      break;
    case "Major":
      //PotGlow = PrizePots.MajorGlow;
      PotValue = PrizePots.whopperPotText;
      scaleDown = { x: 0.25, y: 0.25 };
      break;
    case "Mega":
      //PotGlow = PrizePots.MegaGlow;
      PotValue = PrizePots.monsterPotText;
      break;
  }

  gsap
    .timeline()
    .to(PotValue.scale, {
      duration: 0.25,
      ease: "linear",
      x: 2,
      y: 2,
    })
    .to(PotValue.scale, {
      duration: 0.25,
      ease: "linear",
      x: 1,
      y: 1,
    });

  if (PrizePots.PotIndex >= PrizePots.HorseShoesSymbolTitle.length) {
    PrizePots.PotIndex = 0;
  }

  PrizePots.PotIndex++;
};

PrizePots.playPotPrizeReelSpin = function (pot) {
  PrizePots.PotPrizeReelSpin.visible = false;
  PrizePots.PotPrizeReelSpinLoop.visible = false;
  let potIndex = 0;
  let prizeReel;
  //TODO play loop
  switch (pot.potName) {
    case "Mini":
      potIndex = Math.floor(gameController.UINumGenerator() * PrizePots.MiniPotVariations.length - 1);
      prizeReel = PrizePots.MiniPotVariations[potIndex];
      prizeReel.visible = true;
      prizeReel.gotoAndStop(0);
      prizeReel.play();
      prizeReel.onComplete = PrizePots.potWinComplete.bind(this, pot, potIndex);
      break;
    case "Minor":
      prizeReel = PrizePots.PotPrizeMinorReelSpin;
      prizeReel.visible = true;
      prizeReel.gotoAndStop(0);
      prizeReel.play();
      prizeReel.onComplete = PrizePots.potWinComplete.bind(this, pot);
      break;
    case "Major":
      PrizePots.PotPrizeMajorReelSpin.visible = true;
      PrizePots.PotPrizeMajorReelSpin.gotoAndStop(0);
      PrizePots.PotPrizeMajorReelSpin.play();
      PrizePots.PotPrizeMajorReelSpin.onComplete = PrizePots.potWinComplete.bind(this, pot);
      break;
    case "Mega":
      PrizePots.PotPrizeMegaReelSpin.visible = true;
      PrizePots.PotPrizeMegaReelSpin.gotoAndStop(0);
      PrizePots.PotPrizeMegaReelSpin.play();
      PrizePots.PotPrizeMegaReelSpin.onComplete = PrizePots.potWinComplete.bind(this, pot);
      break;
  }
  timerManager.addTimer(1400, undefined, function () {
    soundManager.play("horseshoeResult");
    musicManager.onPotCollectEnd();
  });
};

PrizePots.potWinComplete = function (pot, potIndex) {
  let prizeReel = undefined;
  let fileName = undefined;
  let scaleDown = { x: 1, y: 1 };
  let posOffset = { x: 0, y: 0 };
  switch (pot.potName) {
    case "Mini":
      prizeReel = PrizePots.MiniPotVariations[potIndex];
      fileName = PrizePots.MiniTitleSpriteFilePath;
      break;
    case "Minor":
      prizeReel = PrizePots.PotPrizeMinorReelSpin;
      fileName = PrizePots.MinorTitleSpriteFilePath;
      break;
    case "Major":
      prizeReel = PrizePots.PotPrizeMajorReelSpin;
      fileName = PrizePots.MajorTitleSpriteFilePath;
      break;
    case "Mega":
      prizeReel = PrizePots.PotPrizeMegaReelSpin;
      fileName = PrizePots.MegaTitleSpriteFilePath;
      break;
  }

  const posX = PrizePots.PotPrizeContianer.position.x + PrizePots.PotPrizeReelSpin.width / 2 + posOffset.x;
  const posY = PrizePots.PotPrizeContianer.position.y + PrizePots.PotPrizeReelSpin.height / 2 + posOffset.y;

  const prizePotsTextContainer = resourceManager.get("postReels:PrizePotsContainerTextContainer");

  PrizePots.potWinText = resourceManager.createObject(
    "sprite",
    "PrizePotText" + PrizePots.HorseShoesSymbolTitle.length,
    prizePotsTextContainer,
    {
      fileName: fileName,
      x: posX,
      y: posY,
      scale: 3,
      anchor: 0.5,
    }
  );
  PrizePots.potWinText.visible = true;

  const symbol = resourceManager.get(`slotContainer:reelContainer:reel${pot.coord.reel}:symbol${pot.coord.row}`);
  const symbolPos = helper.getLocalFromGlobalPosition(symbol, PrizePots.potWinText);

  PrizePots.potWinTextTween = gsap.to(PrizePots.potWinText, {
    duration: 1,
    ease: "power3.in",
    x: symbolPos.x,
    y: symbolPos.y,
  });
  gsap.to(PrizePots.potWinText.scale, {
    duration: 1,
    ease: "linear",
    x: scaleDown.x,
    y: scaleDown.y,
    onComplete: () => {
      if (PrizePots.PotPrizesToDisplay.length === 0) {
        gameController.prizePotAnimationsComplete = true;
      }
    },
  });

  gsap.to(prizeReel, {
    duration: 0.25,
    ease: "linear",
    alpha: 0,
    onComplete: () => {
      PrizePots.hidePotPrizeReels();
    },
  });

  PrizePots.HorseShoesSymbolTitle.push({
    text: PrizePots.potWinText,
    coord: { reel: pot.coord.reel, row: pot.coord.row },
  });

  PrizePots.PotPrizesToDisplay.shift();
  if (PrizePots.PotPrizesToDisplay.length === 0) {
    if (PrizePots.onCompleteCallback !== undefined) {
      PrizePots.onCompleteCallback();
      PrizePots.onCompleteCallback = undefined;
    }
  } else {
    PrizePots.potReveal();
  }
};

PrizePots.hidePotPrizeReels = function () {
  PrizePots.PotPrizeMiniReelSpin.visible = false;
  PrizePots.PotPrizeMiniReelSpinA1.visible = false;
  PrizePots.PotPrizeMiniReelSpinA2.visible = false;
  PrizePots.PotPrizeMinorReelSpin.visible = false;
  PrizePots.PotPrizeMajorReelSpin.visible = false;
  PrizePots.PotPrizeMegaReelSpin.visible = false;
  PrizePots.PotPrizeMiniReelSpin.alpha = 1;
  PrizePots.PotPrizeMiniReelSpinA1.alpha = 1;
  PrizePots.PotPrizeMiniReelSpinA2.alpha = 1;
  PrizePots.PotPrizeMinorReelSpin.alpha = 1;
  PrizePots.PotPrizeMajorReelSpin.alpha = 1;
  PrizePots.PotPrizeMegaReelSpin.alpha = 1;
};

PrizePots.cleanUp = function () {
  Reflex.deregisterEventHandler("orientationChange", PrizePots.orientationChange.bind(self));
  for (let index = 0; index < PrizePots.HorseShoesSymbolTitle.length; index++) {
    const text = PrizePots.HorseShoesSymbolTitle[index].text;
    resourceManager.destroyObject(text.name);
  }
  PrizePots.HorseShoesSymbolTitle = [];
  PrizePots.PotIndex = 0;
};

PrizePots.sortArrayByCoord = function (pots) {
  return pots.sort((a, b) => {
    if (a.coord.reel < b.coord.reel) {
      return -1;
    }
    if (a.coord.reel > b.coord.reel) {
      return 1;
    }
    if (a.coord.row < b.coord.row) {
      return -1;
    }
    if (a.coord.row > b.coord.row) {
      return 1;
    }
    return 0;
  });
};

PrizePots.orientationChange = function () {
  timerManager.addTimer(5, () => {
    if (PrizePots.potWinTextTween !== undefined) {
      PrizePots.potWinTextTween.progress(1);
    }
    if (PrizePots.potWinText !== undefined) {
      PrizePots.potWinText.scale = 0.25;
    }

    for (let index = 0; index < PrizePots.HorseShoesSymbolTitle.length; index++) {
      const tempCoinText = PrizePots.HorseShoesSymbolTitle[index];
      const symbol = resourceManager.get(
        `slotContainer:reelContainer:reel${tempCoinText.coord.reel}:symbol${tempCoinText.coord.row}`
      );
      const symbolPos = helper.getLocalFromGlobalPosition(symbol, PrizePots.potWinText);
      tempCoinText.text.position.setX(symbolPos.x);
      tempCoinText.text.position.setY(symbolPos.y);
      tempCoinText.text.scale = { x: 1, y: 1 };
    }
  });
};
